export default "__VITE_ASSET__c62f82ed__"